import React from 'react';
import {
  Divider as MuiDivider,
  Box
} from '@mui/material';
import { colorLightPink, colorPrimary } from '../../Styles/Colors';

const CustomDivider = ({
  variant = "full-width-horizontal",
  children,
  textAlign = "center",  
  color = colorPrimary,
  thickness = 1,
  insetSize = 16, 
  sx = {},
  ...props
}) => {

  // Simple approach - always return visible dividers
  if (variant === "inset-vertical") {
    return (
      <Box sx={{ height: '100px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <MuiDivider 
          orientation="vertical" 
          sx={{ 
            height: '80px',
            borderColor: color,
            borderWidth: `${thickness}px`,
          }} 
        />
      </Box>
    );
  }

  if (variant === "middle-inset-vertical") {
    return (
      <Box sx={{ height: '100px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <MuiDivider 
          orientation="vertical" 
          sx={{ 
            height: '60px',
            borderColor: color,
            borderWidth: `${thickness}px`,
          }} 
        />
      </Box>
    );
  }

  // Horizontal dividers with text insert support
  if (children) {
    return (
      <MuiDivider 
        textAlign={textAlign}
        sx={{ 
          borderColor: color,
          marginLeft: variant === "inset-horizontal" ? `${insetSize}px` : 
                     variant === "middle-inset-horizontal" ? `${insetSize * 2}px` : 0,
          marginRight: variant === "inset-horizontal" ? `${insetSize}px` : 
                      variant === "middle-inset-horizontal" ? `${insetSize * 2}px` : 0,
          '&::before, &::after': {
            borderColor: color,
            borderTopWidth: `${thickness}px`,
          },
          ...sx
        }}
      >
        {children}
      </MuiDivider>
    );
  }

  // Regular horizontal dividers
  return (
    <MuiDivider 
      sx={{ 
        borderColor: color,
        borderWidth: `${thickness}px`,
        marginLeft: variant === "inset-horizontal" ? `${insetSize}px` : 
                   variant === "middle-inset-horizontal" ? `${insetSize * 2}px` : 0,
        marginRight: variant === "inset-horizontal" ? `${insetSize}px` : 
                    variant === "middle-inset-horizontal" ? `${insetSize * 2}px` : 0,
        ...sx
      }} 
      {...props}
    />
  );
};

export default CustomDivider;
